
import React, { Component}  from 'react';
import { DetailProvider, DetailContext } from 'core/DetailProvider';

import Layout  from 'components/Dashboard/Layout';

import {ListContext, ListProvider} from 'core/ListProvider';
import Paper from '@material-ui/core/Paper';
import TableListFooter from 'core/TableListFooter';
import TableContainer from '@material-ui/core/TableContainer';
import ClientDetailHeader from "../DetailHeader";
import AddContractDialog from "./AddContractDialog";
import ContractListItem from "./ContractListItem";
import {TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import { ResponsiveTable } from 'ui/Table';


export default class ClientDetailContracts extends Component {

  render() {
    const { match, history } = this.props;
    return (
      <DetailProvider
        url={`client/${match.params.id}`}
      >
        <DetailContext.Consumer>
          {context => {
            let { item } = context;

            return (
              <Layout>
                <ClientDetailHeader item={item} history={history} match={match} />

                <Layout.ContentSimple>
                  <ListProvider
                    url={'client/contract'}
                    storageKey={`ListProvider-client_contact-${item.id}`}
                    filterDefaults={{
                      client: item.id,
                      page_size: 20
                    }}
                  >
                   <ListContext.Consumer>
                     {listContext => {
                       const { items } = listContext;

                       return (
                         <>
                           <div className={'mb-10'}>
                             <AddContractDialog client={item} listContext={listContext} />
                           </div>
                           <TableContainer component={Paper}>
                            <ResponsiveTable>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Действующий</TableCell>
                                  <TableCell>Контрагент</TableCell>
                                  <TableCell>Перевозчик</TableCell>
                                  <TableCell>Номер</TableCell>
                                  <TableCell>Дата начала</TableCell>
                                  <TableCell>Дата окончания</TableCell>
                                  <TableCell>Обменялись оригиналами</TableCell>
                                  <TableCell />
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {items.map(item =>
                                  <ContractListItem key={item.id} item={item} listContext={listContext} />
                                )}
                              </TableBody>
                              <TableListFooter showPerPageSelector={false} colspan={9} />
                            </ResponsiveTable>
                          </TableContainer>
                        </>
                       )
                     }}
                   </ListContext.Consumer>
                  </ListProvider>
                </Layout.ContentSimple>
              </Layout>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
